import { render, staticRenderFns } from "./Billing.vue?vue&type=template&id=2fc89e3a"
import script from "./Billing.vue?vue&type=script&lang=js"
export * from "./Billing.vue?vue&type=script&lang=js"
import style0 from "./Billing.vue?vue&type=style&index=0&id=2fc89e3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports